document.addEventListener('DOMContentLoaded', () => {

	const toggles = document.querySelectorAll(
		'.wens-dark-mode-toggle .toggle'
	);

	if (!toggles.length) {
		return;
	}

	toggles.forEach((toggle) => {

		const isDark = document.body.classList.contains('dark-mode');

		toggle.setAttribute('aria-pressed', isDark ? 'true' : 'false');

		toggle.addEventListener('click', () => {

			const isDark = document.body.classList.toggle('dark-mode');

			document.cookie =
				'wens_dark_mode=' +
				(isDark ? 'dark' : 'light') +
				'; path=/; max-age=' +
				60 * 60 * 24 * 365;

			toggle.setAttribute(
				'aria-pressed',
				isDark ? 'true' : 'false'
			);

		});

	});

});